/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import SingleCommunityContentSection from '../../../components/Community/SingleCommunityContentSection/SingleCommunityContentSection';
import ThreeColumnGridLayout from '../../../components/Layout/ThreeColumnGridLayout/ThreeColumnGridLayout';
import {
    Consumer as CommunityContextConsumer,
    Provider as CommunityContextProvider,
} from '../../../contexts/CommunityContext';
import { loadRightRailLayout } from '../../../utilities/loadPageContent';
import { PageContext } from '../../../contexts/ContextCreator';
import './SingleCommunityContentPage.scss';

/**
 * @deprecated Use SingleContentPage instead
 */
export class SingleCommunityContentPage extends React.PureComponent {
    componentDidMount = () => {
        this.setSingleContentPage(true);
    };

    setSingleContentPage = (bool) =>
        this.context.onUpdate('singleContentPage', bool);

    attachGoogleAMP = () => {
        const content = `<script type='application/ld+json'>${this.props.content.googleAMP}</script>`;
        return { __html: content };
    };

    renderGoogleAMP = () => {
        return this.props.content.googleAMP ? (
            <div
                className="google-amp"
                dangerouslySetInnerHTML={this.attachGoogleAMP()}
            />
        ) : null;
    };

    render() {
        const profileLeftRailCTAMetrics = {
            LAT: 'user-left-rail',
            LAC: 'user-left-rail',
            clickMetric: 'user-left-rail-profile-cta-click',
            impressionMetric: 'user-left-rail-profile-cta-impression',
        };
        return (
            <div className="page-Community-SingleCommunityContentPage">
                <ThreeColumnGridLayout
                    allowProfileCTA
                    profileLeftRailCTAMetrics={profileLeftRailCTAMetrics}
                    showCreateContentWidget={false}
                    showSingleContentFeed={this.props.showSingleContentFeed}
                    rightRailContent={loadRightRailLayout('EditorialContent')}
                    currentTopic={this.props.currentTopic}
                    topBannerOnlyShownList={['profile-cta']}
                >
                    <SingleCommunityContentSection {...this.props} />
                    {this.renderGoogleAMP()}
                </ThreeColumnGridLayout>
            </div>
        );
    }
}

export default (props) => (
    <CommunityContextProvider
        singleAttributionContentHash={props.content.hash}
        attributionMode="single"
        content={[props.content]}
        topics={props.topics}
    >
        <CommunityContextConsumer>
            {({ refs, getContent, submitComment }) => (
                <SingleCommunityContentPage
                    {...props}
                    refs={refs}
                    getContent={getContent}
                    submitComment={submitComment}
                />
            )}
        </CommunityContextConsumer>
    </CommunityContextProvider>
);

SingleCommunityContentPage.contextType = PageContext;

SingleCommunityContentPage.propTypes = {
    /**
     * serialized content object
     */
    content: PropTypes.shape({
        author: PropTypes.shape({
            userId: PropTypes.number.isRequired,
            username: PropTypes.string.isRequired,
            hash: PropTypes.string.isRequired,
            image: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired,
            }).isRequired,
            userCommunityData: PropTypes.shape({
                id: PropTypes.number,
                connectionCount: PropTypes.number,
                followerCount: PropTypes.number,
                isVip: PropTypes.number,
            }).isRequired,
            connectWithMeText: PropTypes.string,
            credential: PropTypes.string,
            isCommunityManager: PropTypes.bool,
            isHighlightedUser: PropTypes.bool,
            karmaScore: PropTypes.string,
            location: PropTypes.string,
            publicUrl: PropTypes.string,
            relation: PropTypes.shape({
                connectionStatus: PropTypes.string,
                isFollowing: PropTypes.bool,
            }),
            interests: PropTypes.arrayOf(PropTypes.string),
        }),
        canComment: PropTypes.bool.isRequired,
        category: PropTypes.string,
        commentCount: PropTypes.number,
        contentDate: PropTypes.string,
        deletable: PropTypes.bool,
        editable: PropTypes.bool,
        comments: PropTypes.arrayOf(PropTypes.object).isRequired,
        group: PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            groupUrl: PropTypes.string.isRequired,
            hash: PropTypes.string.isRequired,
            logo: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
            privacySetting: PropTypes.string.isRequired,
        }),
        moderationOption: PropTypes.shape({
            status: PropTypes.string,
            editableFields: PropTypes.arrayOf(PropTypes.string).isRequired,
        }).isRequired,
        reactionBar: PropTypes.shape({
            commenting: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
            liking: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
            flagging: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
            sharing: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
        }).isRequired,
        time: PropTypes.string.isRequired,
        title: PropTypes.string,
        description: PropTypes.string,
        embedHTML: PropTypes.string,
        hash: PropTypes.string.isRequired,
        image: PropTypes.string,
        contentUrl: PropTypes.string.isRequired,
        topic: PropTypes.shape({
            id: PropTypes.number.isRequired,
            isActive: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
        location: PropTypes.string,
        isAnon: PropTypes.bool,
        isPaid: PropTypes.bool,
        likes: PropTypes.number,
        paidCompany: PropTypes.string,
        shell: PropTypes.string,
        streamDate: PropTypes.string,
        subType: PropTypes.string,
        url: PropTypes.string,
        userFlagged: PropTypes.bool,
        userLiked: PropTypes.bool,
        googleAMP: PropTypes.string,
    }),
    /**
     * bool to hide reactino bar
     */
    hideReactionBar: PropTypes.bool,
    refs: PropTypes.objectOf(
        PropTypes.shape({
            author: PropTypes.shape({
                userId: PropTypes.number.isRequired,
                username: PropTypes.string.isRequired,
                hash: PropTypes.string.isRequired,
                image: PropTypes.shape({
                    src: PropTypes.string.isRequired,
                    alt: PropTypes.string.isRequired,
                }).isRequired,
                connectWithMeText: PropTypes.string,
                credential: PropTypes.string,
                interests: PropTypes.arrayOf(PropTypes.string),
                isCommunityManager: PropTypes.bool,
                isHighlightedUser: PropTypes.bool,
                karmaScore: PropTypes.string,
                location: PropTypes.string,
                name: PropTypes.string,
                publicUrl: PropTypes.string,
                relation: PropTypes.shape({
                    isFollowing: PropTypes.bool,
                    connectionStatus: PropTypes.string,
                }),
                userCommunityData: PropTypes.shape({
                    connectionCount: PropTypes.number,
                    followerCount: PropTypes.number,
                    id: PropTypes.number,
                    isVip: PropTypes.number,
                }),
            }),
            comment: PropTypes.string,
            commentCount: PropTypes.number,
            comments: PropTypes.arrayOf(PropTypes.object),
            contentDate: PropTypes.string,
            deletable: PropTypes.bool,
            editable: PropTypes.bool,
            getTotalCount: PropTypes.func,
            hash: PropTypes.string,
            isAnon: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
            isNew: PropTypes.bool,
            likes: PropTypes.number,
            moderationOption: PropTypes.shape({
                editableFields: PropTypes.arrayOf(PropTypes.string),
                status: PropTypes.string,
            }),
            contentType: PropTypes.string,
            type: PropTypes.string,
            parentHash: PropTypes.string,
            parentType: PropTypes.string,
            replyOpened: PropTypes.bool,
            time: PropTypes.string,
            userFlagged: PropTypes.bool,
            userLiked: PropTypes.bool,
        })
    ),
    getContent: PropTypes.func,
    submitComment: PropTypes.func,
    showSingleContentFeed: PropTypes.bool,
    currentTopic: PropTypes.shape({
        id: PropTypes.number,
        isDefault: PropTypes.number,
        layout: PropTypes.string,
        qaDataAttr: PropTypes.string,
        sponsored: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
        }),
        title: PropTypes.string,
        total: PropTypes.number,
        url: PropTypes.string,
    }),
    isPreview: PropTypes.bool,
    showReactionBar: PropTypes.bool,
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            isDefault: PropTypes.number,
            layout: PropTypes.string,
            qaDataAttr: PropTypes.string,
            title: PropTypes.string,
            total: PropTypes.number,
            url: PropTypes.string,
        })
    ),
};

SingleCommunityContentPage.defaultProps = {
    refs: {},
    isPreview: false,
    showReactionBar: true,
    showSingleContentFeed: true,
    topics: [],
    content: {},
    currentTopic: {},
    hideReactionBar: false,
    getContent: () => {},
    submitComment: () => {},
};
